<template>
  <div class="order-sku-list">
    <div
      :key="index"
      class="sku-details van-hairline--bottom"
      v-for="(sku, index) in skuList"
    >
      <a
        @click="
          jumpDetails(sku.item_id, sku.sku_id, sku.platform.name, sku.item_type)
        "
        class="jump-details"
        href="javascript:;"
      >
        <div class="sku-img">
          <img v-lazy="sku.sku_img" />
        </div>
        <div class="sku-desc">
          <div class="sku-intro">
            <div class="sku-title">{{ sku.sku_name }}</div>
            <div class="sku-hint" v-if="sku.attr_list && sku.attr_list[0] && sku.attr_list[0].is_type">
              <i class="red" v-if='Number(sku.attr_list[0].is_type) === 1 && orderDetails.sa * 1 > 0'>可用福利金</i>
              <i v-if='Number(sku.attr_list[0].is_type) === 2 && orderDetails.sb * 1 > 0'>可用爱心币</i>
              <i v-if='Number(sku.attr_list[0].is_type) === 4 && orderDetails.se * 1 > 0'>可用体验金</i>
            </div>
            <div class="sku-name">
              <span v-show="sku.attr_list">
                <em
                  :key="index"
                  v-for="({ attr_value }, index) in sku.attr_list"
                  >{{ attr_value.value }}</em
                >
              </span>
            </div>
            <div class="sku-rebate" v-if="sku.status >= 0">
              <sku-rebate :text="sku.rebate"></sku-rebate>
            </div>
            <div class="order-status" v-else-if="sku.status === -100">
              <span>系统异常,下单失败</span>
            </div>
            <div class="order-status" v-else-if="sku.status === -101">
              <span>商品已拒收</span>
            </div>
            <div class="order-status" v-else>
              <span>------</span>
            </div>
          </div>
          <div class="sku-intro-wrapper">
            <div class="price">¥{{ sku.discount }}</div>
            <div class="num">数量：{{ sku.sku_num }}</div>
            <div class="sku-platform-name">{{ sku.platform.brand }}</div>
          </div>
        </div>
      </a>
      <div class="ticket-tips" v-if="sku.item_type == 2">
        使用该商品请前往“个人中心-订单管理-已购卡券”查看
      </div>
    </div>
  </div>
</template>

<script>
import SkuRebate from '../components/SkuRewardsTipsOrder'
import api from '../utils/api'
let flag = false
export default {
  name: 'orderDetailsSkuList',
  components: {
    SkuRebate
  },
  props: {
    skuList: {
      type: Array,
      require: true
    },
    orderDetails: {
      type: Object,
      require: true
    }
  },
  methods: {
    async jumpDetails (goodsid, skuid, platform, type) {
      if (flag) {
        return false
      }
      flag = true
      await api.routeJump({ goodsid, skuid, platform, type })
      flag = false
    }
  }
}
</script>

<style lang="less" scoped>
.sku-details {
  padding: 0.3rem 0.2rem 0.42rem;
  .ticket-tips {
    margin-top: 0.24rem;
    width: 100%;
    .flex-center;
    height: 0.66rem;
    font-size: @fz24;
    color: #875721;
    background-color: #fff7e7;
  }
  .jump-details {
    width: 100%;
    .flex-between;
  }
  .sku-img {
    width: 2rem;
    height: 2rem;
  }
  .sku-desc {
    display: flex;
    width: 4.5rem;
    justify-content: space-between;
    .sku-intro {
      width: 3.03rem;
      height: 1.9rem;
      .flex-column-between;
      .sku-title {
        .ellipsis2;
        font-size: @fz24;
        color: @base;
      }
      .sku-hint {
        font-size: @fz22;
        color: @member-text;
        i{
          color: #3cd407;
        }
        .red{
            color: #FF3824;
        }
      }
      .sku-name {
        width: 100%;
        display: flex;
        span {
          padding: 0.05rem 0.08rem;
          font-size: @fz20;
          color: @sku-name;
          background-color: #f5f5f5;
          border: 0.5px solid #cbcbcb;
          border-radius: 0.04rem;
          .ellipsis;
        }
      }
    }
    .sku-intro-wrapper {
      width: 1.16rem;
      font-size: @fz24;
      height: 1.9rem;
      .flex-column-between;
      .price {
        color: @base;
      }
      .num {
        color: #696969;
        // padding-top: 0.45rem;
      }
      .sku-platform-name {
        color: #9f9f9f;
      }
    }
  }
  .order-status {
    display: flex;
    align-items: center;
    span {
      font-size: 0.24rem;
      background-color: #ffdada;
      color: #ff2851;
      border-radius: 30px;
      padding: 0.05rem 0.1rem;
    }
  }
}
</style>
